var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialisationErrorRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0C3.74167 0 0 3.74167 0 8.33333C0 12.925 3.74167 16.6667 8.33333 16.6667C12.925 16.6667 16.6667 12.925 16.6667 8.33333C16.6667 3.74167 12.925 0 8.33333 0ZM7.70833 5C7.70833 4.65833 7.99167 4.375 8.33333 4.375C8.675 4.375 8.95833 4.65833 8.95833 5V9.16667C8.95833 9.50833 8.675 9.79167 8.33333 9.79167C7.99167 9.79167 7.70833 9.50833 7.70833 9.16667V5ZM9.1 11.9833C9.05833 12.0917 9 12.175 8.925 12.2583C8.84167 12.3333 8.75 12.3917 8.65 12.4333C8.55 12.475 8.44167 12.5 8.33333 12.5C8.225 12.5 8.11667 12.475 8.01667 12.4333C7.91667 12.3917 7.825 12.3333 7.74167 12.2583C7.66667 12.175 7.60833 12.0917 7.56667 11.9833C7.525 11.8833 7.5 11.775 7.5 11.6667C7.5 11.5583 7.525 11.45 7.56667 11.35C7.60833 11.25 7.66667 11.1583 7.74167 11.075C7.825 11 7.91667 10.9417 8.01667 10.9C8.21667 10.8167 8.45 10.8167 8.65 10.9C8.75 10.9417 8.84167 11 8.925 11.075C9 11.1583 9.05833 11.25 9.1 11.35C9.14167 11.45 9.16667 11.5583 9.16667 11.6667C9.16667 11.775 9.14167 11.8833 9.1 11.9833Z",
    fill: "#ED484B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialisationErrorRow);
export default __webpack_public_path__ + "static/media/initialisation-error-row.56460fa97263e6263f9e3b7126920343.svg";
export { ForwardRef as ReactComponent };